import { createContext } from 'react'
import { ILinkItem, NavbarMenuItem } from '../interfaces'

interface ILayoutContext {
  contacts: {
    text: string
    value: string
  }[]
  navMenu: NavbarMenuItem[]
  ssnn: {
    facebook: string
    instagram: string
    twitter: string
  }
  companyInfo: string
  legalLinks: ILinkItem[]
  subParagraphs: string[]
  menu: {
    Angle: ILinkItem[]
    'Members & Employers': ILinkItem[]
    Providers: ILinkItem[]
    Brokers: ILinkItem[]
  }
}

const navMenu: NavbarMenuItem[] = [
  {
    text: 'Who We Serve',
    key: 'whoWeServe',
    dropdownLinks: [
      {
        text: 'Members',
        link: 'https://www.anglehealth.com/members'
      },
      {
        text: 'Employers',
        link: 'https://www.anglehealth.com/employers'
      },
      {
        text: 'Brokers',
        link: 'https://www.anglehealth.com/brokers'
      },
      {
        text: 'Providers',
        link: 'https://www.anglehealth.com/providers'
      }
    ]
  },
  {
    text: 'About Us',
    key: 'aboutUs',
    dropdownLinks: [
      {
        text: 'About Us',
        link: 'https://www.anglehealth.com/about-us'
      },
      { text: 'Media', link: 'https://www.anglehealth.com/media' },
      {
        text: 'Careers',
        link: 'https://www.anglehealth.com/careers'
      }
    ]
  },
  {
    text: 'Log In',
    key: 'login',
    dropdownLinks: [
      {
        text: 'Member',
        link: 'https://member.anglehealth.com'
      },
      {
        text: 'Employer',
        link: 'https://employer.anglehealth.com'
      },
      {
        text: 'Broker',
        link: 'https://broker.anglehealth.com'
      }
    ]
  }
]

const defValues: ILayoutContext = {
  navMenu,
  contacts: [
    {
      text: 'General inquires',
      value: 'hi@anglehealth.com'
    },
    {
      text: 'For Member Services',
      value: 'members@anglehealth.com, +1 (855) 937-1855'
    },
    {
      text: 'For Provider Services',
      value: 'providers@anglehealth.com, +1 (855) 937-1811'
    },
    {
      text: 'For Sales',
      value: 'sales@anglehealth.com, +1 (855) 590-0333'
    },
    {
      text: 'Fax',
      value: '(855) 938-4540'
    }
  ],
  ssnn: {
    facebook: '#fb',
    instagram: '#ig',
    twitter: '#tw'
  },
  companyInfo: `Copyright © ${new Date().getFullYear()} Angle Health. All rights reserved`,
  legalLinks: [
    {
      text: 'Disclosures',
      link: 'https://www.anglehealth.com/disclosures'
    },
    {
      text: 'Terms & Conditions',
      link: 'https://www.anglehealth.com/terms-conditions'
    },
    {
      text: 'Privacy Policy',
      link: 'https://www.anglehealth.com/privacy-policy'
    }
  ],
  subParagraphs: [
    "Angle Health is a healthcare technology company bringing quality, tech-enabled health insurance plans to the modern employer and their employees. Angle's employer sponsored health insurance plans in the state of Utah are offered by Angle Insurance Company of Utah. Angle, through its subsidiaries Angle Insurance Services and Adrem Administrators, offers employer sponsored health insurance solutions in Ohio, Indiana, Missouri, South Carolina, Arizona, Texas, Georgia, Florida, North Carolina, Nevada, Colorado, Tennessee, and Kentucky issued by Benchmark Insurance Company, an A rated carrier."
  ],
  menu: {
    Angle: [
      {
        text: 'About Us',
        link: 'https://www.anglehealth.com/about-us'
      },
      {
        text: 'Newsroom',
        link: 'https://www.anglehealth.com/media'
      },
      {
        text: 'Careers',
        link: 'https://www.anglehealth.com/careers'
      },
      {
        text: 'Find My Doctor',
        link: 'https://www.anglehealth.com/network-directories'
      }
    ],
    'Members & Employers': [
      {
        text: 'Member Log In',
        link: 'http://member.anglehealth.com/'
      },
      {
        text: 'Employer Log In',
        link: 'http://employer.anglehealth.com/'
      },
      {
        text: 'Overview',
        link: 'https://www.anglehealth.com/members'
      }
    ],
    Providers: [
      {
        text: 'Overview',
        link: 'https://www.anglehealth.com/providers'
      },
      {
        text: 'Provider Resources',
        link: 'https://www.anglehealth.com/providers#provider-resources'
      }
    ],
    Brokers: [
      {
        text: 'Overview',
        link: 'https://www.anglehealth.com/brokers'
      },
      {
        text: 'Partner with us',
        link: 'https://www.anglehealth.com/brokers#contact'
      }
    ]
  }
}

export const LayoutContext = createContext<ILayoutContext>(defValues)

export const LayoutProvider: React.FC = ({ children }) => {
  return (
    <LayoutContext.Provider value={defValues}>
      {children}
    </LayoutContext.Provider>
  )
}
